import { LifeBuoyIcon } from "lucide-react";

import { useUser } from "@/hooks/useUser";

const HELP_CENTER_ROLES = new Set(["admin", "owner", "collaborator"]);
const HELP_CENTER_URL = "https://help.nlc.com/en/";

export function HelpSection() {
  const { data: user } = useUser();

  if (!user) return null;

  return (
    <div className="flex flex-col">
      {HELP_CENTER_ROLES.has(user.user.roleName || "") && (
        <a
          className="flex gap-3 justify-center p-md text-sm font-semibold text-text-secondary hover:text-text-primary"
          href={HELP_CENTER_URL}
          rel="noreferrer"
          target="_blank"
        >
          <LifeBuoyIcon className="size-5 shrink-0 text-nav-item-icon-fg" />
          <span className="whitespace-nowrap">Help center</span>
        </a>
      )}
    </div>
  );
}
